import { Component, Input } from '@angular/core';
import { LucideAngularModule, LogOut } from 'lucide-angular';

@Component({
    selector: 'app-session-revoked-modal',
    standalone: true,
    imports: [LucideAngularModule],
    template: `
        <div class="text-center py-5">
            <lucide-icon [img]="LogOut" [size]="64" [strokeWidth]="2" class="mx-auto mb-6 text-secondary"></lucide-icon>
            <p class="text-gray-700 text-base leading-relaxed mb-6">
                {{ message }}
            </p>
            <div class="flex justify-center">
                <button class="button button--primary" (click)="returnToLogin()">Return to Login</button>
            </div>
        </div>
    `,
})
export class SessionRevokedModalComponent {
    readonly LogOut = LogOut;

    @Input() message: string = 'Your session has been terminated because you logged in from another device.';

    returnToLogin(): void {
        window.location.reload();
    }
}
